module.exports = __webpack_public_path__ + "bg912-blue-5e0d5847094d753effa20bee7ce552fa.png";